import React from "react";
import "../../styles/CheckoutSummary.scss";

interface Props {
  selectedTicket: any;
  quantity: number;
}

const CheckoutSummary: React.FC<Props> = ({ selectedTicket, quantity }) => {
  const price = Number(selectedTicket?.ticket_price) || 0;
  const subtotal = price * quantity;
  const serviceFee = subtotal * 0.055;
  const total = subtotal + serviceFee;

  return (
    <div className="checkout-summary">
      <h4>Checkout Summary</h4>

      <div className="summary-row">
        <span className="label">Quantity:</span>
        <span className="value">{quantity}</span>
      </div>

      <div className="summary-row">
        <span className="label">Subtotal:</span>
        <span className="value">₱{subtotal.toLocaleString()}</span>
      </div>

      <div className="summary-row">
        <span className="label">Convenience Fee:</span>
        <span className="value">₱{serviceFee.toLocaleString()}</span>
      </div>

      <hr />

      <div className="summary-row total">
        <span className="label">Total:</span>
        <span className="value">₱{total.toLocaleString()}</span>
      </div>
    </div>
  );
};

export default CheckoutSummary;
